<template>
  <div class="px-2 mt-10 sm:container mx-auto">
    <h2 class="text-xl text-bold">ผลรางวัลล่าสุด</h2>
    <div
      v-if="!pending"
      class="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mt-2"
    >
      <ResultCardLotto
        v-for="(item, index) in datas"
        :key="index"
        :id="item._id"
        :master_id="item.master_id"
        :master_slug="item.master_slug"
        :master_name="item.master_name"
        :round_display="item.round_display"
        :round="item.round"
        :round_no="item.round_no"
        :status="item.status"
        :open_at="item.open_at"
        :close_at="item.close_at"
        :created_at="item.created_at"
        :updated_at="item.updated_at"
        :secondDif="item.secondDif"
        :results="item.results"
      ></ResultCardLotto>
    </div>
  </div>
</template>
<script setup>
import { set } from "@vueuse/core";
const config = useRuntimeConfig();
const userStore = useUserStore();
const base_api = config.public.apiUri;
const apiUrl = ref(`${base_api}/result/latest`);
const { data: datas, pending } = await useLazyFetch(apiUrl, {
  method: "get",
});
</script>
